<template>
  <el-dialog
    @open="iniciar"
    title="Relatórios Financeiros"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    append-to-body
    width="46%"
    v-loading="loading"
  >
    <el-form
      :model="relatorio"
      :rules="validacao"
      ref="form"
      size="small"
      label-position="top"
      hide-required-asterisk
      :show-message="false"
    >
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form-item label="Relatório" style="font-weight: bold;">
            <el-select
              auto-complete="off"
              v-model="relatorio.nome"
              clearable
              placeholder
              style="width: 100%;"
            >
              <el-option label="Selecione" :value="''" />
              <el-option
                v-for="item in tiposRelatorios"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="Formato" style="font-weight: bold;">
            <el-radio v-model="relatorio.xls" :label="false">PDF</el-radio>
            <el-radio v-model="relatorio.xls" :label="true">Excel</el-radio>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirFiltroOrdenacao" style="margin-bottom: 5px">
        <el-col :span="16" :md="24">
          <el-form-item label="Ordenação" style="width: 100%;font-weight: bold;">
            <el-radio-group v-model="relatorio.ordenacao" label="Tipo" style="font-size: small;">
              <el-radio label="DATA_VENCIMENTO" >Data de Vencimento</el-radio>
              <el-radio v-if="exibirOrdenacaoPorPagamento" label="DATA_PAGAMENTO" >Data de pagamento</el-radio>
              <el-radio v-if="!exibirOrdenacaoPorPagamento" :label="this.relatorio.nome === 'CONTAS_PAGAR' || this.relatorio.nome === 'CONTAS_PAGAR_VENCIDAS' ? 'FORNECEDOR_CLIENTE' : 'CLIENTE'" >
                {{this.relatorio.nome === 'CONTAS_PAGAR' || this.relatorio.nome === 'CONTAS_PAGAR_VENCIDAS' ? 'Nome do Fornecedor/Cliente' : 'Nome do Cliente'}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <span style="font-weight: bold;" v-if="exibirPeriodo">Período</span>
      <el-row :gutter="24" v-if="exibirPeriodo">
        <el-col :span="12">
          <el-form-item prop="dataInicial">
            <el-date-picker
              v-model="relatorio.dataInicial"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="dataFinal">
            <el-date-picker
              v-model="relatorio.dataFinal"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" v-if="exibirDataRemessa">
        <el-col :span="12">
          <el-form-item label="Data Remessa" prop="dataInicial" style="width: 100%;font-weight: bold;">
            <el-date-picker
              v-model="relatorio.dataInicial"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="Conta Bancária (Imobiliária)">
            <el-input size="small" v-model="labelContaBancariaImobiliaria" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button @click="exibirSelecionarContaBancariaDialog()" type="primary" icon="el-icon-search" size="small" style="margin-top: 17px" circle class="btn-box-shadow"/>
        </el-col>
      </el-row>

      <el-row :gutter="24" v-if="exibirFiltrosContas">
        <el-col :span="12">
          <el-form-item label="Tipo de Conta">
            <el-select
              v-model="tipoContaSelecionado"
              :remote-method="filtrarTipoSelect"
              :loading="loadingTipos"
              value-key="id"
              placeholder=""
              loading-text="Carregando Tipos"
              no-data-text="Nenhum Tipo de conta encontrado"
              filterable
              clearable
              @clear="tipoContaSelecionado = undefined"
              remote
              style="width: 100%"
            >
              <el-option
                v-for="item in tiposDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Grupo de Conta">
            <el-select
              v-model="grupoContaSelecionado"
              :remote-method="filtrarGrupoSelect"
              :loading="loadingGrupos"
              value-key="id"
              placeholder=""
              loading-text="Carregando Grupos"
              no-data-text="Nenhum Grupo de conta encontrado"
              filterable
              clearable
              @clear="grupoContaSelecionado = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in gruposDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" v-if="exibirFiltrosContas">
        <el-col :span="12">
          <el-form-item label="Subgrupo de conta">
            <el-select
              v-model="subgrupoContaSelecionado"
              :remote-method="filtrarSubgrupoSelect"
              :loading="loadingSubgrupos"
              value-key="id"
              placeholder=""
              loading-text="Carregando Subgrupos"
              no-data-text="Nenhum Subgrupo de conta encontrado"
              filterable
              clearable
              @clear="subgrupoContaSelecionado = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in subgruposDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Conta">
            <el-select
              v-model="planoContaSelecionado"
              :remote-method="filtrarPlanoContaSelect"
              :loading="loadingPlanosConta"
              value-key="id"
              placeholder=""
              loading-text="Carregando Planos de Contas"
              no-data-text="Nenhum Plano de Conta encontrado"
              filterable
              clearable
              @clear="planoContaSelecionado = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in planosContaDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" v-if="exibirFiltrosContas">
        <el-col :span="24">
          <el-form-item :label="nomeFiltroFornecedorCliente">
            <el-radio v-model="filtroClienteFornecedor" label="TODOS">Todos</el-radio>
            <el-radio v-if="exibirRadioFornecedor" v-model="filtroClienteFornecedor" label="FORNECEDOR">Selecionar Fornecedor</el-radio>
            <el-radio v-model="filtroClienteFornecedor" label="CLIENTE">Selecionar Cliente</el-radio>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="12" v-if="exibirFiltroFornecedor">
          <el-form-item label="Fornecedor">
            <el-select
              v-model="fornecedorSelecionado"
              :remote-method="filtrarFornecedoresSelect"
              :loading="loadingPlanosConta"
              value-key="id"
              placeholder=""
              loading-text="Carregando Fornecedores"
              no-data-text="Nenhum Fornecedor encontrado"
              filterable
              clearable
              @clear="fornecedorSelecionado = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in fornecedoresDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Cliente" v-if="exibirFiltroCliente">
            <el-select
              v-model="clienteSelecionado"
              :remote-method="filtrarClientesSelect"
              :loading="loadingClientes"
              value-key="id"
              placeholder=""
              loading-text="Carregando Clientes"
              no-data-text="Nenhum Cliente encontrado"
              filterable
              clearable
              @clear="clienteSelecionado = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in clientesDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirStatus">
        <el-col :span="16" :md="24">
          <el-form-item label="Status" style="width: 100%;font-weight: bold;">
            <el-radio-group v-model="relatorio.status" style="font-size: small;">
              <el-radio label="TODOS" style="margin-top:5px">Todos</el-radio><br/>
              <el-radio label="EFETUADO" style="margin-top:5px">Compensados</el-radio><br/>
              <el-radio label="ABERTO" style="margin-top:5px">Não Compensados</el-radio><br/>
              <el-radio label="DEVOLVIDO" style="margin-top:5px">Devolvidos</el-radio><br/>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" style="display: flex; justify-content: space-between;" v-if="this.relatorio.nome.length">
      <el-button
        style=""
        @click="limparFiltros"
        :disabled="botaoGerarRelatorioIsDisabled"
        type="warning"
        size="small"
        round
        class="btn-box-shadow">
        Limpar Filtros
      </el-button>
      <el-button
        @click="gerarRelatorioHandler"
        :disabled="botaoGerarRelatorioIsDisabled"
        type="primary"
        size="small"
        round
        class="btn-box-shadow">
        Gerar Relatório
      </el-button>
    </span>
    <app-selecionar-conta-bancaria-dialog @close="fecharSelecionarContaBancariaDialog" :cliente="clienteConta" :visibility="visibilidadeSelecionarContaBancariaDialog" todosOsBancos/>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";

import funcoes from "../../../util/funcoes.js"; 
import AppSelecionarContaBancariaDialog from '../../../shared/dialogs/SelecionarContaBancariaDialog.vue'

export default {
  props: {
    visibility: Boolean,
  },
  components: {
    AppSelecionarContaBancariaDialog,
  },
  created() {
    this.adicionarRelatoriosDisponiveis();
  },

  data() {
    return {
      relatorio: {
        nome: '',
        status: "TODOS",
        ordenacao: "DATA_VENCIMENTO",
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        xls: false
      },
      
      tiposRelatorios: [],

      validacao: {
        dataInicial: [{ required: true }],
        dataFinal: [{ required: true }]
      },
      //CONTA BANCARIA
      visibilidadeSelecionarContaBancariaDialog: false,
      clienteConta: {},
      contaBancaria: {
        id: 0,
        nome: ''
      },

      loadingTipos: false,
      loadingGrupos: false,
      loadingSubgrupos: false,
      loadingPlanosConta: false,
      loadingFornecedores: false,
      loadingClientes: false,

      tipoContaSelecionado: undefined,
      grupoContaSelecionado: undefined,
      subgrupoContaSelecionado: undefined,
      planoContaSelecionado: undefined,
      fornecedorSelecionado: undefined,
      clienteSelecionado: undefined,

      filtroClienteFornecedor: 'TODOS'
    };
  },

  computed: {
    ...mapState('loginStore', {
      permissoesModuloContasPagar(state) {
        return state.usuarioLogado.permissoes
          .filter(permissao => permissao.modulo === 'CONTAS_PAGAR')[0];
      },

      permissoesModuloContasReceber(state) {
        return state.usuarioLogado.permissoes
          .filter(permissao => permissao.modulo === 'CONTAS_RECEBER')[0];
      },
    }),
    ...mapState('financeiroRelatoriosStore', {
      tiposDisponiveis(state) { 
        if(this.relatorio.nome === 'CONTAS_PAGAR_VENCIDAS' || this.relatorio.nome === 'CONTAS_PAGAS'
        || this.relatorio.nome === 'CONTAS_PAGAR'){
          return state.tiposContaDisponiveis.filter(tiposConta => tiposConta.tipo === 'DESPESA')
        }else if( this.relatorio.nome === 'CONTAS_RECEBIDAS'
        || this.relatorio.nome === 'CONTAS_RECEBER_VENCIDAS'
        || this.relatorio.nome === 'CONTAS_RECEBER'){
          return state.tiposContaDisponiveis.filter(tiposConta => tiposConta.tipo === 'RECEITA')
        }else{
          return state.tiposContaDisponiveis
        }
      },
      gruposDisponiveis(state) { 
         if(this.relatorio.nome === 'CONTAS_PAGAR_VENCIDAS' || this.relatorio.nome === 'CONTAS_PAGAS'
        || this.relatorio.nome === 'CONTAS_PAGAR'){
          return state.gruposContaDisponiveis.filter(grupoConta => grupoConta.tipo === 'DESPESA')
        }else if( this.relatorio.nome === 'CONTAS_RECEBIDAS'
        || this.relatorio.nome === 'CONTAS_RECEBER_VENCIDAS'
        || this.relatorio.nome === 'CONTAS_RECEBER'){
          return state.gruposContaDisponiveis.filter(grupoConta => grupoConta.tipo === 'RECEITA')
        }else {
          return state.gruposContaDisponiveis
        } 
      },
      subgruposDisponiveis(state) {
        if(this.relatorio.nome === 'CONTAS_PAGAR_VENCIDAS' || this.relatorio.nome === 'CONTAS_PAGAS'
        || this.relatorio.nome === 'CONTAS_PAGAR'){
          return state.subgruposContaDisponiveis.filter( item => item.grupoPai.tipo === 'DESPESA')
        }else if( this.relatorio.nome === 'CONTAS_RECEBIDAS'
        || this.relatorio.nome === 'CONTAS_RECEBER_VENCIDAS'
        || this.relatorio.nome === 'CONTAS_RECEBER'){
          return state.subgruposContaDisponiveis.filter(item => item.grupoPai.tipo === 'RECEITA')
        }else{
          return state.subgruposContaDisponiveis
        }
      },
      planosContaDisponiveis(state) { 
        if(this.relatorio.nome === 'CONTAS_PAGAR_VENCIDAS' || this.relatorio.nome === 'CONTAS_PAGAS'
        || this.relatorio.nome === 'CONTAS_PAGAR'){
          return state.planosContaDisponiveis.filter( item => item.grupoPlanoConta.tipo === 'DESPESA')
        }else if( this.relatorio.nome === 'CONTAS_RECEBIDAS'
        || this.relatorio.nome === 'CONTAS_RECEBER_VENCIDAS'
        || this.relatorio.nome === 'CONTAS_RECEBER'){
          return state.planosContaDisponiveis.filter(item => item.grupoPlanoConta.tipo === 'RECEITA')
        }else{
          return state.planosContaDisponiveis
        }
      },
      fornecedoresDisponiveis(state) { return state.fornecedoresDisponiveis },
      clientesDisponiveis(state) { return state.clientesDisponiveis },

      labelContaBancariaImobiliaria() {
      return `${this.contaBancaria.nome ? this.contaBancaria.nome : ''} ${this.contaBancaria.conta ? '- Conta: ' + this.contaBancaria.conta : ''}${this.contaBancaria.digitoConta ? '-' + this.contaBancaria.digitoConta : '' }`
    },
    loading() {
      return this.$store.state.loading;
    },
    }),

    exibirPeriodo() {
      return (
        this.relatorio.nome === 'CONTAS_PAGAS'
        || this.relatorio.nome === 'CONTAS_PAGAR'
        || this.relatorio.nome === 'CONTAS_RECEBIDAS'
        || this.relatorio.nome === 'CONTAS_RECEBER'
        || this.relatorio.nome === 'CHEQUES_CONTAS_RECEBER'
      );
    },

    exibirDataRemessa() {
      return (
        this.relatorio.nome === 'REMESSAS_GERADAS_FINANCEIRO'
        )
    },

    exibirStatus() {
      return this.relatorio.nome === 'CHEQUES_CONTAS_RECEBER';
    },

    botaoGerarRelatorioIsDisabled() {
      const nenhumRelatorioFoiSelecionado = this.relatorio.nome === '';

      return nenhumRelatorioFoiSelecionado;
    },

    exibirFiltrosContas() {
      return (
        this.relatorio.nome === 'CONTAS_PAGAS'
        || this.relatorio.nome === 'CONTAS_PAGAR_VENCIDAS'
        || this.relatorio.nome === 'CONTAS_PAGAR'
        || this.relatorio.nome === 'CONTAS_RECEBIDAS'
        || this.relatorio.nome === 'CONTAS_RECEBER_VENCIDAS'
        || this.relatorio.nome === 'CONTAS_RECEBER'
      );
    },

    exibirFiltroOrdenacao() {
      return (
        this.relatorio.nome === 'CONTAS_PAGAS'
        || this.relatorio.nome === 'CONTAS_PAGAR_VENCIDAS'
        || this.relatorio.nome === 'CONTAS_PAGAR'
        || this.relatorio.nome === 'CONTAS_RECEBIDAS'
        || this.relatorio.nome === 'CONTAS_RECEBER_VENCIDAS'
        || this.relatorio.nome === 'CONTAS_RECEBER'
      );
    },

    exibirOrdenacaoPorPagamento(){
      return this.relatorio.nome === 'CONTAS_PAGAS' || this.relatorio.nome === 'CONTAS_RECEBIDAS'
    },

    exibirFiltroCliente() {
      return this.exibirFiltrosContas && this.filtroClienteFornecedor == 'CLIENTE'
    },

    exibirFiltroFornecedor() {
      return (this.relatorio.nome === 'CONTAS_PAGAS' || 
      this.relatorio.nome === 'CONTAS_PAGAR_VENCIDAS' ||
      this.relatorio.nome === 'CONTAS_PAGAR') &&
      this.filtroClienteFornecedor == 'FORNECEDOR'
    },

    exibirRadioFornecedor() {
      return this.relatorio.nome === 'CONTAS_PAGAS' || 
      this.relatorio.nome === 'CONTAS_PAGAR_VENCIDAS' ||
      this.relatorio.nome === 'CONTAS_PAGAR'
    },
    
    nomeFiltroFornecedorCliente() {
      if(this.relatorio.nome === 'CONTAS_PAGAS' ||
      this.relatorio.nome === 'CONTAS_PAGAR_VENCIDAS' ||
      this.relatorio.nome === 'CONTAS_PAGAR') {
        return 'Fornecedor/Cliente'
      } else {
        return 'Cliente'
      }
    }
  },
  watch : {
    'relatorio.nome': function(newValue, oldValue)  {
      if(newValue != oldValue){
        this.relatorio.ordenacao = "DATA_VENCIMENTO"
      }
    }
  },
  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading",
    ]),
    ...mapActions("alugueisRelatoriosStore", [
      "gerarRelatorio",
      
    ]),
    ...mapActions("financeiroRelatoriosStore",[
      "listarTipos",
      "listarGrupos",
      "listarSubgrupos",
      "listarPlanoConta",
      "listarFornecedores",
      "listarClientes"
    ]),

    //CONTA BANCARIA
    exibirSelecionarContaBancariaDialog() {
      this.clienteConta = undefined
      this.visibilidadeSelecionarContaBancariaDialog = true
    },
    fecharSelecionarContaBancariaDialog(contaBancaria) {
      if(contaBancaria && contaBancaria.id !== 0){
        this.contaBancaria = contaBancaria
      }
      this.visibilidadeSelecionarContaBancariaDialog = false;
    },

    gerarRelatorioHandler() {
      this.$refs["form"].validate(elFormValidation => {
        const formIsInvalid = !elFormValidation;
        if(formIsInvalid){
          this.$message.warning("Insira os campos obrigatórios.");
          return;
        }

          const payload = this.getPayload();
          this.showLoading();

          this.gerarRelatorio(payload)
            .then(resultado => {
              switch(resultado.status) {
                case "SUCESSO": {
                  const urlRelatorio = resultado.mensagem;
                  window.open(urlRelatorio, "_blank");
                  break;
                }
                case "FALHA":
                  this.$message.warning("Ocorreu um erro ao gerar o relatório");    
              }
            })
            .catch(() => {
              this.$message.error("Não foi possível comunicar-se com o servidor");
            })
            .finally(() => {
              this.hideLoading();
            });
      });
    },

    getPayload() {
      const payload = {
        ...this.relatorio,
        status: undefined,
        contaBancaria: {id: this.contaBancaria.id, nome: this.contaBancaria.nome},
      };

      const relatoriosQueUsamCampoStatus = [
        'CHEQUES_CONTAS_RECEBER'
      ];

      const relatoriosQueUsamCampoOrdenacao = [
        'CONTAS_PAGAS',
       'CONTAS_PAGAR_VENCIDAS'
       ,'CONTAS_PAGAR'
       ,'CONTAS_RECEBIDAS'
       ,'CONTAS_RECEBER_VENCIDAS'
       ,'CONTAS_RECEBER'

      ];

      const relatorioUsaCampoStatus = relatoriosQueUsamCampoStatus.includes(this.relatorio.nome);
      if(payload.tipoCredor) { return delete payload.tipoCredor }
      if(relatorioUsaCampoStatus) {
        if(this.relatorio.status !== 'TODOS') {
          payload.status = this.relatorio.status;
        }
      }

      const relatoriosUsaCampoOrdenacao = relatoriosQueUsamCampoOrdenacao.includes(this.relatorio.ordenacao);
      if(relatoriosUsaCampoOrdenacao) {
        if(this.relatorio.ordenacao !== 'DATA_VENCIMENTO') {
          payload.ordenacao = this.relatorio.ordenacao;
        }
      }

      if(this.subgrupoContaSelecionado) {
        payload.grupoConta = this.subgrupoContaSelecionado;
      } else if(this.grupoContaSelecionado) {
        payload.grupoConta = this.grupoContaSelecionado;
      } else if(this.tipoContaSelecionado) {
        payload.grupoConta = this.tipoContaSelecionado
      }

      if(this.planoContaSelecionado) { payload.planoConta = this.planoContaSelecionado }

      if(this.fornecedorSelecionado) { 
        payload.tipoCredor = { id: this.fornecedorSelecionado.id }
      }
      if(this.clienteSelecionado) { 
        payload.tipoCredor = { id: this.clienteSelecionado.id }
      }
      
      this.filtroClienteFornecedor = 'TODOS'
      this.fornecedorSelecionado = undefined;
      this.clienteSelecionado = undefined;
      return payload;
    },

    filtrarTipoSelect(queryString) {
      let payload = { nome: queryString }
      this.loadingTipos = true
      this.listarTipos(payload)
      .then(() => {
        this.loadingTipos = false;
      });
    },

    filtrarGrupoSelect(queryString) {
      let payload = { nome: queryString, grupoPai: this.tipoContaSelecionado ? { id: this.tipoContaSelecionado.id } : undefined }
      this.loadingGrupos = true
      this.listarGrupos(payload)
      .then(() => {
        this.loadingGrupos = false;
      });
    },

    filtrarSubgrupoSelect(queryString) {
      let payload = { nome: queryString, grupoPai: this.grupoContaSelecionado ? { id: this.grupoContaSelecionado.id } : undefined }
      this.loadingSubgrupos = true
      this.listarSubgrupos(payload)
      .then(() => {
        this.loadingSubgrupos = false
      });
    },

    filtrarPlanoContaSelect(queryString) {
      let payload = { nome: queryString, grupoPlanoConta: this.subgrupoContaSelecionado ?
      { id: this.subgrupoContaSelecionado.id } : this.grupoContaSelecionado ? 
      { id: this.grupoContaSelecionado.id } : this.tipoContaSelecionado ?
      { id: this.tipoContaSelecionado.id } : undefined }
      this.loadingPlanosConta = true
      this.listarPlanoConta(payload)
      .then(() => {
        this.loadingPlanosConta = false;
      });
    },

    filtrarFornecedoresSelect(queryString) {
      let payload = { nome: queryString }
      this.loadingFornecedores = true
      this.listarFornecedores(payload)
      .then(() => {
        this.loadingFornecedores = false;
      });
    },

    filtrarClientesSelect(queryString) {
      let payload = { nome: queryString }
      this.loadingClientes = true
      this.listarClientes(payload)
      .then(() => {
        this.loadingClientes = false
      });
    },

    adicionarRelatoriosDisponiveis() {
      if(this.permissoesModuloContasPagar && this.permissoesModuloContasPagar.relatorioContasPagas) {
        this.tiposRelatorios.push({ label: "Contas Pagas", value: "CONTAS_PAGAS" });
      }
      if(this.permissoesModuloContasPagar && this.permissoesModuloContasPagar.relatorioContasAPagar) {
        this.tiposRelatorios.push({ label: "Contas a Pagar", value: "CONTAS_PAGAR" });
      }
      if(this.permissoesModuloContasPagar && this.permissoesModuloContasPagar.relatorioContasAPagarVencidas) {
        this.tiposRelatorios.push({ label: "Contas a Pagar Vencidas", value: "CONTAS_PAGAR_VENCIDAS" });
      }
      if(this.permissoesModuloContasReceber && this.permissoesModuloContasReceber.relatorioContasRecebidas) {
        this.tiposRelatorios.push({ label: "Contas Recebidas", value: "CONTAS_RECEBIDAS" });
      }
      if(this.permissoesModuloContasReceber && this.permissoesModuloContasReceber.relatorioContasAReceber) {
        this.tiposRelatorios.push({ label: "Contas a Receber", value: "CONTAS_RECEBER" });
      }
      if(this.permissoesModuloContasReceber && this.permissoesModuloContasReceber.relatorioContasAReceberVencidas) {
        this.tiposRelatorios.push({ label: "Contas a Receber Vencidas", value: "CONTAS_RECEBER_VENCIDAS" });
      }
      if(this.permissoesModuloContasReceber && this.permissoesModuloContasReceber.relatorioCheques) {
        this.tiposRelatorios.push({ label: "Cheques", value: "CHEQUES_CONTAS_RECEBER" });
      }
      if(this.permissoesModuloContasReceber && this.permissoesModuloContasReceber.relatorioRemessasGeradasFinanceiro) {
        this.tiposRelatorios.push({ label: "Remessas Geradas", value: "REMESSAS_GERADAS_FINANCEIRO"});
      }
    },

    iniciar() {
      this.reset();
    },

    reset() {
      this.relatorio = {
        nome: '',
        status: "TODOS",
        ordenacao: "DATA_VENCIMENTO",
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        xls: false,
      };

      this.contaBancaria = { id: 0, nome: ''},
      this.tipoContaSelecionado = undefined,
      this.grupoContaSelecionado = undefined,
      this.subgrupoContaSelecionado = undefined,
      this.planoContaSelecionado = undefined,
      this.fornecedorSelecionado = undefined,
      this.clienteSelecionado = undefined,
      
      this.filtroClienteFornecedor = 'TODOS'
    },
    limparFiltros() {
      this.relatorio = {
        nome: this.relatorio.nome,
        status: "TODOS",
        ordenacao: "DATA_VENCIMENTO",
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        xls: false,
      };

      this.contaBancaria = { id: 0, nome: ''},
      this.tipoContaSelecionado = undefined,
      this.grupoContaSelecionado = undefined,
      this.subgrupoContaSelecionado = undefined,
      this.planoContaSelecionado = undefined,
      this.fornecedorSelecionado = undefined,
      this.clienteSelecionado = undefined,
      
      this.filtroClienteFornecedor = 'TODOS'
    },

    fechar() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.form-item {
  width: 100%;
}
.select {
  font-size: 50%;
}
</style>